module.exports = {"id":"215699","name":"Youssouf Sabaly","rating":"76","photo":"./data/images/photos/1/215699.png","club":{"name":"Girondins de BX","logo":"./data/images/clubs/GirondinsdeBX.png"},"positions":["DD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YoussoufSabaly0.json
// module id = 4436
// module chunks = 0